<template>
  <el-dialog
    title="地图选择"
    v-model="dialogVisible"
    width="80%"
    destroy-on-close
    @close="handleClose"
  >
    <div class="map-container">
      <div id="mapContainer" class="map-content"></div>
      <div class="map-search">
        <el-input
          v-model="searchText"
          placeholder="输入地址搜索"
          @keyup.enter="searchLocation"
        >
          <template #append>
            <el-button @click="searchLocation">搜索</el-button>
          </template>
        </el-input>
        <div class="search-results" v-if="searchResults.length > 0">
          <div
            v-for="(item, index) in searchResults"
            :key="index"
            class="search-item"
            @click="selectSearchResult(item)"
          >
            <div class="item-title">{{ item.name }}</div>
            <div class="item-address">{{ item.address }}</div>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmSelection">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'MapDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    initialLocation: {
      type: Object,
      default: () => ({
        latitude: 39.90923,
        longitude: 116.397428
      })
    }
  },
  emits: ['update:visible', 'location-selected', 'address-selected'],
  data() {
    return {
      dialogVisible: false,
      map: null,
      marker: null,
      searchText: '',
      searchResults: [],
      selectedLocation: null,
      selectedAddress: ''
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.$nextTick(() => {
          this.initMap()
        })
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    initMap() {
      // Initialize the map after the component is mounted
      this.$nextTick(() => {
        // Check if the Tianditu API is available
        const T = window.T
        if (T) {
          // Create a new map instance
          this.map = new T.Map('mapContainer')
          
          // Set the center and zoom level
          const center = new T.LngLat(
            this.initialLocation.longitude, 
            this.initialLocation.latitude
          )
          this.map.centerAndZoom(center, 13)
          
          // Add controls
          this.map.addControl(new T.Control.Zoom())
          this.map.addControl(new T.Control.Scale())
          
          // Add a marker at the center
          this.addMarker(center)
          
          // Add click event to the map
          this.map.addEventListener('click', (e) => {
            const lnglat = e.lnglat
            this.addMarker(lnglat)
            this.reverseGeocode(lnglat)
          })
        } else {
          console.error('Tianditu API is not loaded')
        }
      })
    },
    addMarker(lnglat) {
      const T = window.T
      // Remove existing marker
      if (this.marker) {
        this.map.removeOverLay(this.marker)
      }
      
      // Create a new marker
      this.marker = new T.Marker(lnglat)
      this.map.addOverLay(this.marker)
      
      // Save the selected location
      this.selectedLocation = {
        longitude: lnglat.lng,
        latitude: lnglat.lat
      }
    },
    searchLocation() {
      if (!this.searchText) return
      
      const T = window.T
      // Use the Tianditu search service
      const searchService = new T.LocalSearch(this.map, {
        pageCapacity: 5,
        onSearchComplete: (results) => {
          this.searchResults = []
          if (results && results.getCount() > 0) {
            for (let i = 0; i < results.getCount(); i++) {
              const poi = results.getPoi(i)
              this.searchResults.push({
                name: poi.name,
                address: poi.address,
                location: {
                  longitude: poi.lonlat.lng,
                  latitude: poi.lonlat.lat
                }
              })
            }
          }
        }
      })
      
      searchService.search(this.searchText)
    },
    selectSearchResult(item) {
      const T = window.T
      // Move the map to the selected location
      const lnglat = new T.LngLat(
        item.location.longitude,
        item.location.latitude
      )
      
      this.map.panTo(lnglat)
      this.addMarker(lnglat)
      
      // Save the selected address
      this.selectedAddress = item.address
      this.searchResults = []
    },
    reverseGeocode(lnglat) {
      const T = window.T
      // Use the Tianditu geocoding service to get the address
      const geocoder = new T.Geocoder()
      geocoder.getLocation(lnglat, (result) => {
        if (result.getStatus() === 0) {
          const address = result.getAddress()
          this.selectedAddress = address
        }
      })
    },
    confirmSelection() {
      if (this.selectedLocation) {
        this.$emit('location-selected', this.selectedLocation)
        if (this.selectedAddress) {
          this.$emit('address-selected', this.selectedAddress)
        }
        this.dialogVisible = false
      }
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    // Safe method to check if an object has a property
    hasProperty(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop)
    }
  }
}
</script>

<style scoped>
.map-container {
  position: relative;
  height: 500px;
}

.map-content {
  width: 100%;
  height: 100%;
}

.map-search {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 300px;
  z-index: 1000;
}

.search-results {
  background-color: white;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-top: 5px;
  max-height: 300px;
  overflow-y: auto;
}

.search-item {
  padding: 10px;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
}

.search-item:hover {
  background-color: #f5f7fa;
}

.item-title {
  font-weight: bold;
}

.item-address {
  font-size: 12px;
  color: #606266;
}
</style>
